import { useCallback, useEffect, useState } from "react";

interface Props {
  /** Sysadmin só - configura a org escolhida no seletor em vez da própria. */
  orgId?: string;
}

/** Política de retenção de dados (epico 10/LGPD) - por org; ausente = indefinida. */
export function RetentionPanel({ orgId }: Props) {
  const [days, setDays] = useState<string>("");
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : "";

  const load = useCallback(async () => {
    const r = await fetch(`/api/admin/org/retention${qs}`);
    if (r.ok) {
      const j = (await r.json()) as { dataRetentionDays: number | null };
      setDays(j.dataRetentionDays === null ? "" : String(j.dataRetentionDays));
    }
  }, [qs]);

  useEffect(() => {
    void load();
  }, [load]);

  const save = async () => {
    setBusy(true);
    setError(null);
    setSaved(false);
    try {
      const r = await fetch(`/api/admin/org/retention${qs}`, {
        method: "PUT",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ dataRetentionDays: days.trim() === "" ? null : Number(days) }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        setError(j.error ?? "Falha ao salvar.");
        return;
      }
      setSaved(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
    <div className="admin-block">
      <h2>Retenção de dados</h2>
      <p className="admin-user-meta" style={{ marginBottom: 10 }}>
        Conversas e eventos de atividade mais antigos que este prazo são apagados automaticamente, todo
        dia. Deixe em branco pra manter tudo indefinidamente (comportamento atual).
      </p>
      <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
        <label className="field" style={{ width: 160 }}>
          <span>Dias de retenção</span>
          <input
            type="number"
            min={1}
            value={days}
            onChange={(e) => setDays(e.target.value)}
            placeholder="indefinida"
          />
        </label>
        <button className="btn-approve" disabled={busy} onClick={() => void save()} type="button">
          Salvar
        </button>
      </div>
      {error && <div className="auth-error" style={{ marginTop: 8 }}>{error}</div>}
      {saved && !error && (
        <div className="admin-empty small" style={{ color: "var(--success, #2a9d5c)", marginTop: 8 }}>
          Configuração salva.
        </div>
      )}
    </div>

    <div className="admin-block">
      <h2>Portabilidade (LGPD)</h2>
      <p className="admin-user-meta" style={{ marginBottom: 10 }}>
        Baixa um pacote JSON com os dados da organização: usuários (sem credenciais), conversas,
        workspaces, faturas, pacotes, webhooks e metadados das chaves de API. Segredos nunca saem
        (hash de senha, segredo 2FA, tokens Git e valor de chave ficam fora). O download fica
        registrado na auditoria.
      </p>
      <button
        className="btn-approve"
        type="button"
        onClick={() => window.open(`/api/admin/org/export${orgId ? `?orgId=${encodeURIComponent(orgId)}` : ""}`, "_blank", "noopener")}
      >
        Exportar dados da organização
      </button>
    </div>
    </>
  );
}